import { createApi } from '@reduxjs/toolkit/query/react';

import { fetchBaseQueryWithTokenCheck } from '@shared/utils/api.utils';

import type { Asset, AssetsStatusesEntry } from '../asset-management.types';

export const assetManagementApiSlice = createApi({
  reducerPath: 'assetManagementApi',
  baseQuery: fetchBaseQueryWithTokenCheck,
  endpoints: (builder) => {
    return {
      getAssets: builder.query<Asset[], void>({
        query: () => '/api/v1/asset',
      }),
      getAssetsStatuses: builder.query<AssetsStatusesEntry[], void>({
        query: () => '/api/v1/asset/status',
      }),
    };
  },
});

export const { useGetAssetsQuery, useGetAssetsStatusesQuery } = assetManagementApiSlice;
